// extracted by mini-css-extract-plugin
module.exports = {"LabelSmall":"SettingLabel_LabelSmall__3G06p","Label":"SettingLabel_Label__NgUYi"};